export default (
  state = {
    preference: "",
    often: "",
    purpose: "",
    country: "",
    preferencedropdown: false,
    oftendropdown: false,
    purposedropdown: false,
    countrydropdown: false,
    preferenceerror: false,
    oftenerror: false,
    purposeerror: false,
    countryerror: false
  },
  action
) => {
  switch (action.type) {
    case "SET_DATA":
      return {
        ...state,
        ...{ [action.payload.key]: action.payload.value }
      };
    case "SET_Q_DROPDOWN":
      return {
        ...state,
        ...{ [action.payload.key]: action.payload.value }
      };
    case "CLOSE_DROPDOWNS":
      return {
        ...state,
        ...{
          preferencedropdown: false,
          oftendropdown: false,
          purposedropdown: false,
          countrydropdown: false
        }
      };
    default:
      return state;
  }
};
